import { render, staticRenderFns } from "./DepositRequest.vue?vue&type=template&id=50a75b5e&"
import script from "./DepositRequest.vue?vue&type=script&lang=ts&"
export * from "./DepositRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports